import "core-js/modules/es6.regexp.split";
import { auto } from "../enums.js";
export default function getBasePlacement(placement) {
  return placement.split('-')[0];
}